import type { ReactNode } from 'react';

export const symbol_flash_auto: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m666-626-37 95q-3 8-9.56 12.5-6.56 4.5-14.44 4.5-13.59 0-21.3-11.5Q576-537 581-550l114-291q6-16 18.5-26t29.5-11q17-1 30 10t19 27l114 292q5 12.89-2.53 23.95Q895.94-514 882.23-514q-8.23 0-14.73-4.5T858-531l-37-95H666Zm16-47h123l-54-148h-15l-54 148ZM260-272l186-268H320l81-280H140v360h120v188Zm-55.4 133.3q-4.6-5.39-4.6-13.3v-248h-60q-24.75 0-42.37-17.63Q80-435.25 80-460v-360q0-24.75 17.63-42.38Q115.25-880 140-880h278q23 0 38 18.5t8 41.5l-64 220h74q26.87 0 39.94 24Q527-552 511-529L241-139q-5 7-11.5 8.5t-13.4-.66q-6.9-2.15-11.5-7.54ZM260-460H140h120Z"
		/>
	</svg>
);
